var normalizeComponent = require("!../../../developer-tools/node_modules/vue-loader/lib/component-normalizer")
/* script */
import __vue_script__ from "!!babel-loader?{\"extends\":\"/usr/local/app/frontend/developer-tools/.babelrc\"}!./year-filter.js"/* template */
import __vue_template__ from "!!../../../developer-tools/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6bcee55c\",\"hasScoped\":false,\"buble\":{\"transforms\":{}}}!../../../developer-tools/node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!./year-filter.pug"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ../source/common/year-filter/year-filter.vue
// module id = 1022
// module chunks = 0